export default {
	APP_BASE_API: '/jxedu_admin_api'
}



// WEBPACK FOOTER //
// ./src/config/base-config.js